import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NoteType } from '@app/shared/components/note/note.interface';

@Component({
  standalone: false,
  selector: 'sbnb-connect-booking-choose-method',
  templateUrl: './connect-booking-choose-method.component.html',
  styleUrls: ['./connect-booking-choose-method.component.scss'],
})
export class ConnectBookingChooseMethodComponent implements OnInit {
  @Output() stepComplete = new EventEmitter();

  NoteType = NoteType;

  constructor() { }

  ngOnInit(): void { }
}
